import { render, staticRenderFns } from "./listado_condicion_fisica.vue?vue&type=template&id=59ef5f2c&"
import script from "./listado_condicion_fisica.vue?vue&type=script&lang=js&"
export * from "./listado_condicion_fisica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports